<template>
  <div
    class="relative "
    :class="{ 'w-full': isMobile() && showSidebarOnMobile }"
  >
    <button
      v-if="isMobile() && !showSidebarOnMobile"
      @click="toggleSidebar"
      class="absolute z-50 top-15 bg-indigo-500 rounded-r-md  text-white p-2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 5l7 7-7 7M5 5l7 7-7 7"
        />
      </svg>
    </button>
    <div
      class=" lg:flex flex-col  w-full max-w-xs flex-grow flex-shrink-0 border-r bg-gray-300 h-full"
      style="min-width:350px"
      :class="{
        'absolute z-50': isMobile() && showSidebarOnMobile,
        'relative z-10': !isMobile(),
        hidden: isMobile() && !showSidebarOnMobile
      }"
    >
      <div
        class="flex-shrink-0 px-4 py-2 flex items-center justify-between border-b bg-gray-200"
      >
        <select
          v-model="status"
          class=" block w-full py-1 text-xs font-semibold text-gray-600 bg-transparent cursor-pointer"
          @change="statusChanged"
        >
          <option selected value="open">Mine & Open</option>
          <option value="assigned">Assigned</option>
          <option value="closed">Closed</option>
        </select>
        <div v-if="isMobile() && showSidebarOnMobile" @click="toggleSidebar">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
      </div>
      <div class="flex-1 overflow-y-auto h-full bg-white" @scroll="onScroll">
        <div class="shadow">
          <div v-for="chat in chats" class="max-h-32 border-t relative" :key="chat.id">
            <router-link
              :to="{
                name: 'TeamInboxChat',
                params: { conversationId: chat.id }
              }"
              class="block px-6 pt-3 pb-4 bg-white border-l-4 border-transparent hover:bg-gray-100"
              active-class="active"
              ><div class="flex justify-between">
                <span class="text-xs font-semibold text-gray-900">
                  {{ chat.customer.firstName }}
                </span>
                <span class="text-xs text-gray-600">
                  <!-- v-relativedate="chat.createdAt" -->
                  {{ chat.lastReplyTime | relativetime }}
                </span>
              </div>

              <p class="mt-1 text-xs text-gray-600 truncate pr-12">
                {{ chat.preview }}
                <span
                  v-if="getChatCount(chat.id) > 0"
                  class="inline-block w-9 text-center py-1 leading-none text-xs font-semibold text-gray-700 bg-gray-300 rounded-full absolute right-6"
                >
                  {{ getChatCount(chat.id) }}
                </span>
              </p></router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndex, filter, sortBy } from "lodash-es";
import { getDatabase, ref, onChildAdded, get, off } from "firebase/database";

import Utils from "../../Mixins/utils";
import Helpers from "../../Mixins/helpers";

export default {
  mixins: [Utils, Helpers],
  data() {
    return {
      status: "open",
      userId: "",
      storeId: "",
      initialChatDataLoaded: false,
      isLoading: false,
      showSidebarOnMobile: false
    };
  },
  computed: {
    chats() {
      const chats = this.$store.getters["Inbox/getChats"];
      const userId = this.userId;
      let temp = [];
      if (this.status === "open") {
        temp = filter(
          chats.docs,
          chat =>
            (!chat.assignedTo || chat.assignedTo === userId) &&
            chat.status === "active" &&
            !chat.isDeleted
        );
      } else if (this.status === "closed") {
        temp = filter(chats.docs, chat => chat.status === "closed");
      } else {
        temp = filter(
          chats.docs,
          chat =>
            chat.assignedTo && chat.assignedTo !== userId && !chat.isDeleted
        );
      }
      return sortBy(temp, ["lastReplyTime"]).reverse();
    },
    chatCounts() {
      return this.$store.getters["Inbox/getChatCounts"];
    }
  },
  async created() {
    this.userId = await this.getUserId();
    this.storeId = await this.getStoreId();
    this.loadChats();
    this.listenChatChanges(this.storeId);
    const db = getDatabase();
    this.$store.dispatch(
      "Inbox/getCounts",
      ref(db, `chatCounts/${this.storeId}`)
    );
  },
  destroyed() {
    this.clearActiveListeners();
  },
  methods: {
    statusChanged() {
      this.loadChats(1);
    },
    loadChats(page = 1) {
      this.isLoading = true;
      this.$store
        .dispatch("Inbox/get", {
          page,
          status: this.status
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    listenChatChanges(storeId) {
      console.log("listening to chat changes", storeId);
      const db = getDatabase();
      this.chatsRef = ref(db, "chatsFeed/" + storeId);

      onChildAdded(this.chatsRef, snapshot => {
        if (this.initialChatDataLoaded) {
          const chatId = snapshot.key;
          const chat = snapshot.val();
          const chats = this.$store.getters["Inbox/getChats"];
          const idx = findIndex(chats.docs, { id: chatId });
          if (idx === -1) {
            this.$store.commit("Inbox/ADD_CHAT", { ...chat });
          } else {
            this.$store.commit("Inbox/UPDATE_CHAT", { chat, index: idx });
          }
        }
      });
      get(this.chatsRef).then(() => {
        this.initialChatDataLoaded = true;
      });
    },
    clearActiveListeners() {
      if (this.chatsRef) {
        off(this.chatsRef);
      }
    },
    getChatCount(chatId) {
      return this.chatCounts[chatId]
        ? Object.keys(this.chatCounts[chatId]).length
        : 0;
    },
    async loadMoreChatsIfPossible() {
      const chats = this.$store.getters["Inbox/getChats"];
      const nextPage = parseInt(chats.page) + 1;
      if (this.isLoading === false && nextPage <= chats.pages) {
        this.loadChats(nextPage);
      }
    },
    onScroll(event) {
      const innerHeight = event.target.scrollHeight;
      const offsetHeight = event.target.offsetHeight;
      const scrollTop = event.target.scrollTop;

      console.log("innerHeight", innerHeight);
      console.log("offsetHeight", offsetHeight);
      console.log("scrollTop", scrollTop);
      // const isBottomOfContainer = offsetHeight + scrollTop >= innerHeight;
      if (scrollTop + offsetHeight === innerHeight) {
        this.loadMoreChatsIfPossible();
      }
    },
    toggleSidebar() {
      this.showSidebarOnMobile = !this.showSidebarOnMobile;
    }
  }
};
</script>

<style lang="scss" scoped>
.active {
  @apply bg-indigo-100 border-l-4 border-indigo-500;
}
</style>
